/* Parallax scrolling effect */
export default function parallax() {
	var parallaxElement = $(".parallax"),
		parallaxQuantity = parallaxElement.length;

	if (parallaxElement.length > 0) {
		window.requestAnimationFrame(function() {
			for (var i = 0; i < parallaxQuantity; i++) {
				var currentElement = parallaxElement.eq(i),
					windowTop = $(window).scrollTop(),
					elementTop = currentElement.offset().top,
					elementHeight = currentElement.height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight,
					multiplier = currentElement.attr('data-depth') * (currentElement.hasClass('is-reverse') ? -1 : 1),
					amount = scrolled * multiplier;
				
				currentElement.css({
					transform: `translate3d(0,${amount}px, 0)`
				});
			}
		});
	}
}
